/**
 * @desc 商城查询供需审核分页列表
 */
import {
  PageSupplyDemandEntity,
  SupplyDemandPageQuery
} from '@eastcoal/api/trade/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QuerySupplyDemandPageParameter = SupplyDemandPageQuery

const method = 'GET'
const url = '/trade/mall/supplyDemand/page'

export const querySupplyDemandPageApi = (
  params?: QuerySupplyDemandPageParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<PageSupplyDemandEntity>({
    method,
    url,
    params,
    ...config
  })
}

querySupplyDemandPageApi.method = method
querySupplyDemandPageApi.url = url
